import { Heading, Icon } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'

type Props = {
  heading?: string
  description?: string
  withArrow?: boolean
  onClick?: () => void
} & BoxProps

export const HightlightMessage = ({
  heading,
  description,
  withArrow = true,
  styles,
  classNames,
  className,
  onClick,
  ...boxProps
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__VoucherMessage',
    styles,
    classNames,
  })
  return (
    <Box
      className={cx(classes.root, className)}
      {...boxProps}
      onClick={onClick}
    >
      <Box className={classes.header}>
        {heading && (
          <Heading className={classes.heading} tag="h6">
            {heading}
          </Heading>
        )}
        {withArrow && (
          <Icon.ArrowRightTail
            className={classes.icon}
            size={20}
            useCurrentColor
          />
        )}
      </Box>
      {description && (
        <Text className={classes.description} size="n1">
          {description}
        </Text>
      )}
    </Box>
  )
}
